<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ label(params.value) }}</span>
  </vs-chip> </template
>;
<script>
import { VesselMixin } from "@/mixins";
export default {
  name: "CellRendererStatus",
  mixins: [VesselMixin],
  computed: {
    chipColor() {
      return value => {
        return this.vesselStatus.properties[value].color
      };
    },
    label(){
      return value => {
        return this.vesselStatus.properties[value].label
      };
    }
  }
};
</script>

<style lang="scss" scpoped></style>
